import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import HotelPaymentTbo from '../HotelDetailsTbo/HotelPaymentTbo';
import HotelPaymentTripjack from '../HotelDetailsTripjack/HotelPaymentTripjack';

const HotelPaymentTripjackTbo = () => {
    const location = useLocation();

    return (
        <>
            {location?.state?.vendor === "TBO" &&
                <HotelPaymentTbo />
            }

            {location?.state?.vendor === "TRIPJACK" &&
                <HotelPaymentTripjack />
            }
        </>
    )
}

export default HotelPaymentTripjackTbo